import { PTRAB_PAGES } from '@app/shared/enums/pages/pages.enum';
import { getPtrabUrlFromMap } from '@app/shared/enums/pages/pages.urls';
import { Permissions } from '@app/shared/enums/permissions/permissions.enum';
import { ILinkCard } from '@app/shared/interfaces/link-card/link-card.interface';

const exworkersCardsData: ILinkCard[] = [
  {
    title: 'EXWORKERS.PAYSLIPS',
    icon: 'assets/imgs/icons/salary 1.svg',
    link: getPtrabUrlFromMap(PTRAB_PAGES.PAYSLIPS),
    permissions: [Permissions.EXEMPLOYEE_PAYSLIPS]
  },
  {
    title: 'EXWORKERS.WITHHOLDING_CERTIFICATE',
    icon: 'assets/imgs/icons/bars.svg',
    link: getPtrabUrlFromMap(PTRAB_PAGES.PERSONAL_INCOME_TAX),
    permissions: [Permissions.EXEMPLOYEE_WITHHOLDING]
  },
  {
    title: 'EXWORKERS.CONTRIBUTION_CERTIFICATE',
    icon: 'assets/imgs/icons/accounting-coins-bill.svg',
    link: '',
    permissions: [Permissions.EXEMPLOYEE_CONTRIBUTIONS]
  }
];

export const EXWORKERS_CARDS = exworkersCardsData;
